<template>
  <div>
    <div class="row text-left">
      <div class="col-12 col-lg-12">
        <div class="d-flex flex-column">
          <h6 class="tituloH6 color-trabalho bold mb-2">
            Histórico profissional
          </h6>
          <p class="caption1 color-gray-400">
            Adicione, uma por vez, as empresas onde você trabalhou. Você pode
            inserir quantas quiser. Comece com o cargo mais atual e depois
            inclua os anteriores.
          </p>
        </div>
        <div class="col-12 col-lg-12 mb-64" v-for="(item, key) in valueInternal" :key="key">
          <experience-item v-if="editItemKey !== key" v-model="item.data" @remove="removeItem(key)" @edit="editItem(key)"></experience-item>
          <experience-form v-if="editItemKey == key" v-model="formEdit"></experience-form>
          <div class="d-flex mb-40 justify-content-between" v-if="editItemKey == key">
            <a
              href="javascript:void(0);"
              class="mt-4 adicionar-experiencia body2 bold color-trabalho"
              @click="closeEdit()"
            >Cancelar</a>
            <a
              href="javascript:void(0);"
              class="mt-4 salvar-experiencia body2 bold color-trabalho"
              @click="saveEdit()"
              >Salvar</a
            >
          </div>
          <hr>
        </div>
        <experience-form v-show="isAddNew" v-model="formNew"></experience-form>
      </div>
    </div>
    <div class="d-flex mb-40 justify-content-between">
      <a
        v-show="!isAddNew"
        href="javascript:void(0);"
        class="mt-4 adicionar-formacao body2 bold color-trabalho"
        @click="btnAddNew"
        >Adicionar outra experiência</a
      >
      <a
        v-show="isAddNew"
        href="javascript:void(0);"
        class="mt-4 salvar-idioma body2 bold color-trabalho mr-0 ml-auto"
        @click="btnSaveNew"
        >Salvar</a
      >
    </div>
  </div>
</template>

<script>
import ExperienceForm from './subcomponents/ExperienceForm.vue'
import ExperienceItem from './subcomponents/ExperienceItem.vue'
const defaultFormData = {
  companyName: '',
  jobName: '',
  dateInit: null,
  dateFinish: null,
  isActualJob: false,
  about: '',
}
export default {
  name: "ExperienceInputComponent",
  components:{
    ExperienceForm,
    ExperienceItem
  },
  props: ['value'],
  data() {
    return {
      isAddNew: false,
      formNew: Object.assign({}, defaultFormData),
      formEdit: null,
      editItemKey: null
    }
  },
  watch: {
    formNew: {
      deep: true, 
      handler(value) {
        if (value === undefined) return;
        this.hasChanges = this.wasChanged(value);
        this.$emit('formHasChange', this.hasChanges);
      }
    }
  },
  mounted() {
     this.setAddNew()
  },
  computed: {
    valueInternal: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("update:value", value);
      },
    },
  },
  methods: {
    wasChanged(value){
      for(var key in value) {
        if (value[key] !== defaultFormData[key]) {
          return true;
        }
      }
      return false;
    },
    removeItem(index) {
      this.valueInternal.splice(index, 1);
    },
    setEditItem(index) {
      let item = this.valueInternal[index];
      this.formEdit = JSON.parse(JSON.stringify(item.data));
      this.editItemKey = index;
    },
    editItem(index) {
      if (this.isAddNew) {
        
        this.$swal({
          title: 'Você tem certeza?',
          text: "Ao tentar editar um item, o novo item não será salvo.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, continuar',
          cancelButtonText: 'Não'
        }).then((result) => {
          if (result.isConfirmed) {
            this.closeNew();
            this.setEditItem(index);
          }
        })
      } else {
        this.setEditItem(index);
      }
    },
    setAddNew() {
      this.closeEdit();
      this.isAddNew = true
    },
    btnAddNew() {
      if (this.editItemKey != null) {
        this.$swal({
          title: 'Você tem certeza?',
          text: "Ao tentar criar um novo item, o item que você está editando não será salvo.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, continuar',
          cancelButtonText: 'Não'
        }).then((result) => {
          if (result.isConfirmed) {
            this.closeEdit();
            this.setAddNew();
          }
        })
      } else {
        this.setAddNew();
      }
      
    },
    closeEdit() {
      this.editItemKey = null;
      this.formEdit = null;
    },
    saveEdit() {
      let self = this;
      let newItem = JSON.parse(JSON.stringify(this.formEdit));
      Object.entries(newItem).forEach(([key, value]) => {
        self.valueInternal[self.editItemKey].data[key] = value
      });
      this.closeEdit();
    },
    closeNew() {
      this.isAddNew = false;
      this.formNew = {
        companyName: '',
        jobName: '',
        dateInit: null,
        dateFinish: null,
        isActualJob: false,
        about: '',
      }
    },
    btnSaveNew() {
      this.valueInternal.push({
        data: this.formNew
      });
      this.closeNew();
    }
  },
};
</script>

<style scoped>
</style>
